export default {
    28: {
        type: 'BASIC',
    },
    8912: {
        type: 'SMART2',
        cancellationPeriod: 3,
    },
    8911: {
        type: 'SMART7',
        cancellationPeriod: 8,
    },
    8914: {
        type: 'SMART14',
        cancellationPeriod: 15,
    },
    8915: {
        type: 'SMART30',
        cancellationPeriod: 31,
    },
}